<template>
  <b-row class="align-items-end">
    <b-col
      sm="12"
      md="6"
    >
      <SearchTextInput
        v-model="searchValue"
        label="User Group"
        placeholder="ID or Name"
        @keyup.enter.native="fetchFilter()" />
    </b-col>
    <b-col
      sm="12"
      md="6">
      <StatusDropdown
        :status-filter.sync="statusFilterValue"
        @change-status-filter="fetchFilter()"
      />
    </b-col>
    <b-col
      sm="0"
      md="9"></b-col>
    <b-col
      sm="12"
      md="3"
      class="mt-1">
      <b-button
        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
        class="w-100"
        variant="primary"
        style="align-self: end;"
        @click="fetchFilter()">
        <feather-icon
          icon="SearchIcon"
          class="mr-50 mr-md-0 mr-lg-0 mr-xl-50" />
        <span class="align-middle">Search</span>
      </b-button>
    </b-col>
  </b-row>
</template>

<script>
import SearchTextInput from '@/components/Filter/SearchTextInput.vue'
import StatusDropdown from '@/components/Filter/StatusDropdown.vue'

export default {
  components: {
    StatusDropdown,
    SearchTextInput
  },
  props: {
    search: {
      type: String,
      default: ''
    },
    statusFilter: {
      type: String,
      default: null
    }
  },
  computed: {
    searchValue: {
      get () {
        return this.search
      },
      set (val) {
        this.$emit('update:search', val)
      }
    },
    statusFilterValue: {
      get () {
        return this.statusFilter
      },
      set (val) {
        this.$emit('update:status-filter', val)
      }
    }
  },
  methods: {
    fetchFilter () {
      this.$emit('fetch-filter')
    }
  }
}
</script>

<style>

</style>
